export default __webpack_public_path__ + "static/media/3a7daddb-0a78-4734-a699-6fe08d0e8b99.92855c31.ttf";